import omit from 'lodash/omit';
import type { IssueRestoreMeta } from '../../common/types.tsx';
import type { IssueRestoreMetaControllerState } from './types.tsx';

/**
 * State needs to be parsed before storing in indexed-db
 * @param triggerIssueCreateModalState
 * @returns
 */
export function convertStateToIssueRestoreMeta(
	state: IssueRestoreMetaControllerState,
): IssueRestoreMeta {
	// removing these since they are only in IssueRestoreMetaControllerState not IssueRestoreMeta
	return omit(state, ['isInitialised', 'isSavingCounter', 'restoreMetaError']);
}
